import React from 'react';
import isNil from 'lodash/isNil';
import styled from 'styled-components';
import { TooltipIcon } from 'components/Tooltip';
import { H4, Text } from 'components/Typography';
import { theme } from 'design';
import { toRem } from 'design/utils';

export const Layout = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${toRem(theme.space.md)};
  width: 100%;
`;

export const Header = styled.header`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

interface ITableSectionProps {
  isLoading?: boolean;
  headerText: string;
  headerCount?: number;
  dataCy?: string;
  tooltipText?: string;
  tooltipId?: string;
  children?: React.ReactNode;
}

const TableSection: React.FC<ITableSectionProps> = ({ isLoading, headerText, headerCount, dataCy = 'table-section', tooltipText, tooltipId, children }) => (
  <Layout data-cy={dataCy}>
    <Header>
      <H4 fontWeight="medium" data-cy={`${dataCy}-header`}>
        {headerText}
      </H4>
      {!isLoading && !isNil(headerCount) && <Text size="small" data-cy={`${dataCy}-header-count`}>{`\u00A0(${headerCount})`}</Text>}
      {tooltipText && tooltipId && (
        <TooltipIcon id={tooltipId} iconSize={13.25} iconMarginLeft={theme.space.xs} dataCy={`${dataCy}-tooltip`}>
          {tooltipText}
        </TooltipIcon>
      )}
    </Header>
    {children && children}
  </Layout>
);

export default TableSection;
